import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup } from '@angular/material';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';
import { TravelerCheckComponent } from '../traveler-check/traveler-check.component';
// import { forEach } from '@angular/router/src/utils/collection';
// import { element } from '@angular/core/src/render3/instructions';
import { v4 as uuidv4 } from 'uuid';


@Component({
  selector: 'app-reg-on-trip',
  templateUrl: './reg-on-trip.component.html',
  styleUrls: ['./reg-on-trip.component.css']
})
export class RegOnTripComponent implements OnInit {

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  showTravelerTable = true;
  showVisaDetail = false;
  selectedTab = 0;

  //Tables & Data:
  private add_depend_list = [];
  private traveler_list = [];
  private add_room_list = [];
  private add_visa_list = [];
  private add_hotel_list = [];
  private add_bus_list = [];

  dependDataSource = new MatTableDataSource(this.add_depend_list);
  travelerDataSource = new MatTableDataSource(this.traveler_list);
  roomDataSource = new MatTableDataSource(this.add_room_list);
  hotelDataSource = new MatTableDataSource(this.add_hotel_list);
  visaDataSource = new MatTableDataSource(this.add_visa_list);
  busDataSource = new MatTableDataSource(this.add_bus_list);
  @ViewChild(MatSort) sort: MatSort;

  dependDisplayedColumns = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no',
    'traveler_type', 'relative_relation', 'comment', 'del'];

  travelerDisplayedColumns = ['customer_name', 'age', 'bed', 'ticket', 'food', 'visa_req',
    'depart_date', 'arrival_date', 'room_type', 'price'];

  roomDisplayedColumns = ['hotel_name', 'arrival_date', 'depart_date', 'room_type', 'count',
    'amount', 'edit', 'del'];

  hotelDisplayedColumns = ['hotel_name', 'arrival_date', 'depart_date', 'room_type', 'count',
    'edit', 'del'];

  visaDisplayedColumns = ['country_name', 'count', 'edit', 'del'];

  busDisplayedColumns = ['bus_no', 'depart_date', 'return_date', 'from_city', 'to_city', 'male_seat_count',
    'female_seat_count', 'edit', 'del'];

  model = {
    'chx_addDepend': '0', 'depend_no': '', 'comment': '', 'room_type_id': '0', 'room_type': '',
    'count': '', 'amount': '', 'amount_comment': '', 'total_amount': '0', 'depend_count': '',
    'bed_count': '', 'room_total_amount': '0', 'ext_amount': '0', 'total_after_discount': '0',
    'price_w_tax': '0', 'has_cash_receipt': 0, 'old_total_amount': 0, 'taxable_price': '0',
    'seat_total': '0', 'bed_total': '0', 'ext_amount_no_tax': '0', 'invoice_date': new Date()
  };

  invoice_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'customer_no': '', 'customer_name': '', 'calc_tax': '0', 'print_tax': '1', 'total': '', 'tax': '0',
    'discount': '0', 'rep_emp_no': '0', 'deliver_date': '0000-00-00', 'payment_date': '0000-00-00',
    'invoice_type': 'program', 'cond_list_id': '0', 'transport_fee': '0', 'received_by': '', 'is_paid': '0',
    'status': '1', 'cost_center': '0', 'sales_acct': '0', 'acct_number': '0', 'flag': 'new', 'key': 'invoice_id',
    'qutation_no': '', 'tax_acct': '0', 'trans_acct': '0', 'payment_method': '', 'comment': '',
    'meter_reading': '', 'worker': '', 'group_number': '', 'trip_id': '', 'pnr': '', 'pass_count': '',
    'bed_count': '0', 'seat_count': '0', 'agent_acct_number': '0', 'no': '0',
    'year': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'store_id': '0', 'total_no_tax': '0', 'invoice_uuid': ''
  };

  invoice_item_model = {
    'table_name': 'invoice_item', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'sub_item_number': '0', 'sub_item_name': '', 'price': '0', 'unit_id': '0', 'count': '',
    'total_price': '0', 'tax_no': '', 'invoice_item_id': '0', 'tax_amount': '', 'type': 'p',
    'flag': 'new', 'key': 'invoice_item_id', 'discount': '0', 'stock_no': '0', 'store_id': '0',
    'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 'revenue_acct_no': '0'
  }

  inv_payment_model = {
    'table_name': 'inv_payment_method', 'invoice_no': '', 'inv_payment_method_id': '0', 'flag': 'new',
    'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': '', 'amount': ''
  }

  group_model = {
    'table_name': 'trip_group', 'group_id': '0', 'invoice_no': '', 'head_id': '', 'member_id': '',
    'member_head_relation': '', 'is_active': '1', 'group_type': '', 'trip_arrival_date': '', 
    'trip_depart_date': '', 'member_age': '', 'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 
    'bed_count': '0', 'price': '0', 'room_type_id': '', 'flag': 'new', 'key': 'group_id', 'comment': ''
  };

  hotel_model = {
    'table_name': 'reg_on_hotel', 'reg_id': '0', 'invoice_no': '', 'room_type_id': '0', 'count': '',
    'flag': 'new', 'key': 'reg_id', 'comment': '', 'city_id': '0', 'hotel_id': '0',
    'room_price': '', 'room_cost': '', 'package': '', 'room_type': '', 'hotel_name': '', 'tax_no': '',
    'tax_type': '', 'room_tax_amount': '', 'checkin_date': '', 'checkout_date': '', 'index': 0,
    'amount': '', 'trip_hotel_id': '0'
  }

  visa_model = {
    'table_name': 'reg_on_visa', 'reg_visa_id': '0', 'invoice_no': '', 'visa_tax_amount': '0',
    'country_id': '0', 'country_name': '', 'visa_count': '', 'visa_price': '0', 'visa_cost': '0',
    'visa_total': '0', 'tax_no': '', 'tax_type': '', 'taxable_price': '0', 'tax': '0', 'total_amount': '',
    'flag': 'new', 'key': 'reg_visa_id', 'comment': '', 'visa_tax': '0', 'final_total': '', 'index': 0
  }

  bus_model = {
    'table_name': 'reg_on_bus', 'reg_bus_id': '0', 'trip_bus_id': '0', 'bus_id': '0', 'depart_date': '',
    'return_date': '', 'flag': 'new', 'key': 'reg_bus_id', 'from_city': '0', 'to_city': '0', 'invoice_no': '',
    'comment': '', 'male_seat_count': '0', 'female_seat_count': '0', 'addition_count': '', 'seat_price': '0', 'seat_cost': '0',
    'tax_type': '', 'tax_no': '', 'seat_part_price': '0', 'seat_tax_amount': '0', 'from_city_name': '',
    'from_city_name_en': '', 'to_city_name': '', 'to_city_name_en': ''
  }

  revenue_acct_no = '0';

  //Select Lists:
  country_list = [];
  hotel_list = [];
  hotel_room_list = [];
  room_list = [];
  hotel_room_type = [];
  bus_list = [];

  addDialogRef: MatDialogRef<TravelerComponent>;
  checkDialogRef: MatDialogRef<TravelerCheckComponent>;

  // General Variables:
  seat_count = 0;
  bed_count = 0;
  avail_room_count = 0;

  trip_info = { 'trip_number': '', 'trip_name': '', 'tax_type': '' };
  main_trav_info = { 'customer_name': '', 'customer_name_en': '', 'customer_last_name': '' };
  
  trip_tax = {};
  trip_age_price = [];
  trip_trav_list = [];

  no = '';
  registered_count = '0';
  pass_count = 0;
  toDelete = [];
  contract_no = '';
  acct_number = '';
  cond_list_id = '0';

  //Search Objects:

  search_traveler = {
    'placeholder': 'رقم المسافر/ اسم المسافر/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'join_table': '`traveler_info`',
      'join_condition': " AND (`customer`.`branch_id` = '" + this.invoice_model['branch_id'] +
        "' OR `customer`.`branch_id` = '0') AND `customer`.`acct_number` = `traveler_info`.`acct_number`"
    }]
  };

  mainTraveler = '';
  saveClicked = false;

  limit_amount = 0;
  agent_balance = 0;
  remain_balance = 0;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }


  //Translate:
  Traveler_Placeholder;
  Depend_Msg; Del_Depend_Msg; Room_Type_Msg; Del_Room_Msg;
  Success_Msg; Error_Msg; Inv_No_Msg; Main_Traveler_Msg;
  Depend_Num_Msg; Total_Msg; Reg_Count_Msg; Country_Msg;
  Bus_Msg; Trav_Exist_Msg; Hotel_Msg; New; Trav_Expiry_Msg;
  Avail_Room_Count_Msg; Agent_Limit_Msg;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Traveler_Placeholder').subscribe((res: string) => {
      this.Traveler_Placeholder = res;
    });
    this.search_traveler['placeholder'] = this.Traveler_Placeholder;

    translate.get('Depend_Msg').subscribe((res: string) => {
      this.Depend_Msg = res;
    });

    translate.get('Del_Depend_Msg').subscribe((res: string) => {
      this.Del_Depend_Msg = res;
    });

    translate.get('Room_Type_Msg').subscribe((res: string) => {
      this.Room_Type_Msg = res;
    });

    translate.get('Del_Room_Msg').subscribe((res: string) => {
      this.Del_Room_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });

    translate.get('Main_Traveler_Msg').subscribe((res: string) => {
      this.Main_Traveler_Msg = res;
    });

    translate.get('Depend_Num_Msg').subscribe((res: string) => {
      this.Depend_Num_Msg = res;
    });

    translate.get('Total_Msg').subscribe((res: string) => {
      this.Total_Msg = res;
    });

    translate.get('Reg_Count_Msg').subscribe((res: string) => {
      this.Reg_Count_Msg = res;
    });

    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });

    translate.get('Bus_Msg').subscribe((res: string) => {
      this.Bus_Msg = res;
    });

    translate.get('Trav_Exist_Msg').subscribe((res: string) => {
      this.Trav_Exist_Msg = res;
    });

    translate.get('Hotel_Msg').subscribe((res: string) => {
      this.Hotel_Msg = res;
    });

    translate.get('New').subscribe((res: string) => {
      this.New = res;
    });
    
    translate.get('Trav_Expiry_Msg').subscribe((res: string) => {
      this.Trav_Expiry_Msg = res;
    }); 

    translate.get('Avail_Room_Count_Msg').subscribe((res: string) => {
      this.Avail_Room_Count_Msg = res;
    });

    translate.get('Agent_Limit_Msg').subscribe((res: string) => {
      this.Agent_Limit_Msg = res;
    });
  }

  ngOnInit() {
    console.log('Branch id: ' + this.applicationConstants.user_branch_info.user_branch_id);
    let query, obj;

    // get leaf income accts
    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length > 0)
          this.revenue_acct_no = data.data['list'][0]['acct_number'];
      });

    if (this.applicationConstants.user_info['user_id'] == undefined) {
      this.search_traveler['table_list'][0]['join_condition'] += " AND `customer`.`agent_acct_number` = '" + 
        this.applicationConstants.user_info['acct_number'] + "'";

      obj = { cmd: 'getAcctBalance', acct_number: this.applicationConstants.user_info['acct_number'], acct_type: 'acct', for_agent: '1' };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.limit_amount = this.applicationConstants.user_info['limit_amount'];
          this.agent_balance = Number(data.status['msg']) * -1;
          this.remain_balance = Number(this.applicationConstants.user_info['limit_amount']) - Number(data.status['msg']);
        });
    }
    else  
      this.search_traveler['table_list'][0]['join_condition'] += " AND `customer`.`agent_acct_number` = ''";

    //------------------------ Get Trip Information ------------------------//

    this.route.params.subscribe(params => {
      this.invoice_model['trip_id'] = params['id'];

      obj = { cmd: 'getTripDetail', trip_id: this.invoice_model['trip_id'] };

      this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'error') 
            alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

          else if (data.status['type'] == 'success') {
            let result = data.status['msg'][0];
            this.trip_info = result['trip_info'];
            this.invoice_model['cond_list_id'] = this.trip_info['cond_list_id'];

            if (this.trip_info['cond_list_id'] == '0') {

              query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE `branch_id` = '" + 
                this.invoice_model['branch_id'] + "' AND `invoice_type_key` = 'normal_credit_invoice'"; // + condition;
              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.data['list'].length > 0) {
                    this.cond_list_id = data.data['list'][0]['cond_list_id'];
                    this.invoice_model['cond_list_id'] = this.cond_list_id;
                  }
                });
            }

            // get tax detail
            this.trip_tax = result['trip_tax'];
            
            if (this.trip_info['tax_type'] == 'part_price')
              this.model['taxable_price'] = (this.trip_info['price_for_tax'] == '' ? '0' : this.trip_info['price_for_tax']);

            // get country list:
            this.country_list = result['country_list'];
            this.country_list.unshift({ 'country_id': '0', 'country_name': 'اختر ...', 'country_name_en': 'Select' });


            // get hotel list:
            this.hotel_list = result['hotel_list'];
            this.hotel_list.unshift({ 'trip_hotel_id': '0', 'hotel_id': '0', 'hotel_name': 'اختر ...', 'hotel_name_en': 'Select', 'arrival_date': '', 'depart_date': '' });

            // get hotel room list:
            this.hotel_room_list = result['hotel_room_list'];
            console.log(this.hotel_room_list);

            // get bus list:
            this.bus_list = result['bus_list'];
            this.bus_list.unshift({ 'bus_id': '0', 'bus_no': 'اختر/ Select', 'from_city_name': '', 
              'to_city_name': '' });

            //show columns based on price type:
            if (this.trip_info['price_type'] == 'room') {
              this.travelerDisplayedColumns = ['customer_name', 'age', 'ticket', 'food', 'visa_req',
                'depart_date', 'arrival_date', 'room_type', 'price'];
            }
            else if (this.trip_info['price_type'] == 'age') {
              this.travelerDisplayedColumns = ['customer_name', 'age', 'bed', 'ticket', 'food', 'visa_req',
                'depart_date', 'arrival_date', 'price'];

              this.trip_age_price = result['age_list'];
            }

            this.room_list = result['room_list'];
            this.room_list.unshift({ 'room_type_id': '0', 'room_type': 'اختر/ Select' });
          }
        
          //get trip travelers list:

          query = "SELECT `trip_group`.* FROM `trip_group`, `invoice` WHERE `invoice`.`trip_id` = '" +
            this.invoice_model['trip_id'] + "' AND `invoice`.`invoice_no` = `trip_group`.`invoice_no`" +
            " AND `trip_group`.`status` = '1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              this.trip_trav_list = data.data['list'];
              console.log(this.trip_trav_list);
            });

          //------------------------ Edit Mode ------------------------//

          if (params['no'] != undefined && params['no'] != '') {
            this.no = params['no'];
            this.contract_no = this.no;

            //Get the number of regesterd travelers on the trip:

            let obj = { cmd: 'getTravelerCount', trip_id: this.invoice_model['trip_id'], 
              invoice_no: this.no };

            this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success')
                  this.registered_count = data.status['msg'][0]['registered_count'];
                else
                  alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
              });

            this.getRegOnTrip();
          }
          else {
            this.contract_no = this.New;

            // Get the store id
            let obj;

            if (this.applicationConstants.user_info['user_id'] != undefined) {
              let user_id = this.applicationConstants.user_info['user_id'];

              //get store list:
              let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
                " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
                " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
                "' AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let store_list = [];
                  store_list = data.data['list'];
                  this.invoice_model['store_id'] = store_list['0']['store_id'];
                });
            }
            else {
              let query = "SELECT `store`.* FROM `store` WHERE `store`.`branch_id` = '" + 
                this.applicationConstants.user_branch_info.user_branch_id + "' AND `store`.`status` = '1'";

              obj = { cmd: 'getList', query: query };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let store_list = [];
                  store_list = data.data['list'];
                  this.invoice_model['store_id'] = store_list['0']['store_id'];
                });
            }

            //Get the number of regesterd travelers on the trip:

            obj = { cmd: 'getTravelerCount', trip_id: this.invoice_model['trip_id'] };

            this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success')
                  this.registered_count = data.status['msg'][0]['registered_count'];
                else
                  alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
              });
          }

          if (params['no'] == '' && params['acct_no'] != undefined) {
            this.acct_number = params['acct_no'];
            this.invoice_model['customer_no'] = params['acct_no'];
            let query, obj;

            query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`" +
              " WHERE `customer`.`acct_number` = `traveler_info`.`acct_number`" +
              " AND `customer`.`acct_number` = '" + this.invoice_model['customer_no'] + "'";

            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                this.main_trav_info = data.data['list'][0];
                this.mainTraveler = this.main_trav_info['acct_number'] + '-' + this.main_trav_info['customer_name'] + '-' +
                  this.main_trav_info['customer_name_en'] + '-' + this.main_trav_info['mobile'];
                
                (document.getElementById('search_value_2') as HTMLInputElement).disabled = true;

                let birthdate = new Date(this.main_trav_info['date_of_birth']);
                let arrivaldate = new Date(this.trip_info['arrival_date']);
                let timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());  // 10/26/2023 Date.now() 
                let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

                let price = 0;
                if (this.trip_info['price_type'] == 'age') {
                  this.trip_age_price.forEach(element => {
                    if (age >= element.period_from && age < element.period_to)
                      price = Number(element.price_bed);
                  });
                }

                this.traveler_list.unshift({
                  'acct_number': this.main_trav_info['acct_number'], 'customer_name': this.main_trav_info['customer_name'],
                  'national_id': this.main_trav_info['national_id'], 'mobile': this.main_trav_info['mobile'],
                  'passport_no': this.main_trav_info['passport_no'], 'traveler_type': 'رئيسي', 'comment': '',
                  'flag': 'new', 'key': 'group_id', 'departure_date': this.trip_info['departure_date'],
                  'arrival_date': this.trip_info['arrival_date'], 'room_type_id': '', 'type': 'main', 'age': age,
                  'relative_relation': 'رئيس المجموعة', 'index': this.traveler_list.length, 'price': price.toFixed(2), 'invoice_no': '',
                  'group_id': '0', 'bed_count': '1', 'ticket_count': '1', 'visa_price': '0', 'food_price': '0'
                });


                // get the dependant
                query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`," +
                  " `traveler_trip` WHERE `customer`.`acct_number` = `traveler_info`.`acct_number`" +
                  " AND `customer`.`acct_number` = `traveler_trip`.`acct_number` AND" + 
                  "`traveler_trip`.`head_id` = '" + this.invoice_model['customer_no'] + 
                  "' AND `traveler_trip`.`trip_id` = '" + this.invoice_model['trip_id'] + "'";

                obj = { cmd: 'getList', query: query };
                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    this.model['depend_count'] = data.data['list'].length;

                    if (data.data['list'].length > 1) {
                      this.model['chx_addDepend'] = '1';
                      (document.getElementById('chx_addDepend') as HTMLInputElement).checked = true;
                    }

                    data.data['list'].forEach(element => {

                      birthdate = new Date(element['date_of_birth']);
                      arrivaldate = new Date(this.trip_info['arrival_date']);
                      timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());  // 10/26/2023 Date.now() 
                      // timeDiff = Math.abs(Date.now() - birthdate.getTime());
                      age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

                      price = 0;
                      if (this.trip_info['price_type'] == 'age') {
                        this.trip_age_price.forEach(element => {
                          if (age >= element.period_from && age < element.period_to)
                            price = Number(element.price_bed);
                        });
                      }

                      this.add_depend_list.push({
                        'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                        'customer_name_en': element['customer_name_en'] + " " + element['customer_last_name'],
                        'national_id': element['national_id'], 'mobile': element['mobile'],
                        'passport_no': element['passport_no'], 'traveler_type': 'تابع', 'comment': element.group_comment,
                        'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                        'index': this.add_depend_list.length, 'departure_date': this.trip_info['departure_date'],
                        'arrival_date': this.trip_info['arrival_date'], 'room_type_id': '',
                        'price': price.toFixed(2), 'group_id': '0', 'bed_count': '1', 'ticket_count': '1', 
                        'visa_price': '0', 'food_price': '0', 'table_name': 'trip_group'
                      });
        
                      this.traveler_list.push({
                        'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                        'national_id': element['national_id'], 'mobile': element['mobile'],
                        'passport_no': element['passport_no'], 'traveler_type': 'تابع',
                        'comment': element.group_comment, 'flag': 'new', 'key': 'group_id',
                        'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                        'index': this.traveler_list.length, 'departure_date': this.trip_info['departure_date'],
                        'arrival_date': this.trip_info['arrival_date'], 'room_type_id': '',
                        'price': price.toFixed(2), 'group_id': '0', 'bed_count': '1', 'ticket_count': '1', 
                        'visa_price': '0', 'food_price': '0'
                      });
                    });

                    this.dependDataSource = new MatTableDataSource(this.add_depend_list);
                    this.dependDataSource.sort = this.sort;

                    this.travelerDataSource = new MatTableDataSource(this.traveler_list);
                    this.travelerDataSource.sort = this.sort;

                    this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
                    
                    // calculate total price
                    this.calculateTotalAmount();

                  });

              });
          }
        });
    });
  }

  //------------------------ On Change Search ------------------------//

  onChangeMainTraveller = function (search_result: object) {
    let trav_exist = false;
    this.trip_trav_list.forEach(element => {
      if (search_result['no'] == element.member_id)
        trav_exist = true;
    });

    if (trav_exist) {
      alert(this.Trav_Exist_Msg);
      (document.getElementById('search_value_2') as HTMLInputElement).value = '';
      return;
    }
    
    let old_customer_no = '', travelIndex;

    if (search_result['no'] != '') {
      let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`, `traveler_info`" +
        " WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
        " AND `customer`.`acct_number` = '" + search_result['no'] + "'";

      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.main_trav_info = data.data['list'][0];
          let timeDiff;

          // check the id/ passport expiry date
          // let expiryDate = new Date(this.main_trav_info['passport_expiry_date']);
          // console.log('expiryDate: ' + expiryDate);
          // if (expiryDate.toString() == "Invalid Date" || new Date() > expiryDate) {
          //   alert(this.Trav_Expiry_Msg);
          //   (document.getElementById('search_value_2') as HTMLInputElement).value = '';
          //   return;
          // }
          // else {
          //   timeDiff = Math.abs(Date.now() - expiryDate.getTime());
          //   let period = (timeDiff / (1000 * 3600 * 24)) / 365.25;
          //   console.log('Date: ' + new Date());
          //   console.log('timeDiff: ' + timeDiff);
          //   console.log('period: ' + period);

          //   if (Number(period) < 0.50) {
          //     alert(this.Trav_Expiry_Msg);
          //     (document.getElementById('search_value_2') as HTMLInputElement).value = '';
          //     return;
          //   }
          //   else {
              let birthdate = new Date(this.main_trav_info['date_of_birth']);
              let arrivaldate = new Date(this.trip_info['arrival_date']);
              timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());  // 10/26/2023 Date.now() 
              // timeDiff = Math.abs(Date.now() - birthdate.getTime());
              let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

              old_customer_no = this.invoice_model['customer_no'];
              this.invoice_model['customer_no'] = search_result['no'];
              this.invoice_model['acct_number'] = search_result['no'];
    
              if (old_customer_no != '') {
                travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', old_customer_no);
    
                if (this.traveler_list[travelIndex]['group_id'] != '0') {
                  this.traveler_list[travelIndex]['flag'] = 'delete';
                  this.traveler_list[travelIndex]['table_name'] = 'trip_group';
                  this.toDelete.push(this.traveler_list[travelIndex]);
                }
    
                this.traveler_list.splice(travelIndex, 1);
              }

              let price = 0;
              if (this.trip_info['price_type'] == 'age') {
                this.trip_age_price.forEach(element => {
                  if (age >= element.period_from && age < element.period_to)
                    price = Number(element.price_bed);
                });
              }

              this.traveler_list.unshift({
                'acct_number': this.main_trav_info['acct_number'], 'customer_name': this.main_trav_info['customer_name'],
                'national_id': this.main_trav_info['national_id'], 'mobile': this.main_trav_info['mobile'],
                'passport_no': this.main_trav_info['passport_no'], 'traveler_type': 'رئيسي', 'comment': '',
                'flag': 'new', 'key': 'group_id', 'departure_date': this.trip_info['departure_date'],
                'arrival_date': this.trip_info['arrival_date'], 'room_type_id': '', 'type': 'main', 'age': age,
                'relative_relation': 'رئيس المجموعة', 'index': this.traveler_list.length, 'price': price.toFixed(2), 'invoice_no': '',
                'group_id': '0', 'bed_count': '1', 'ticket_count': '1', 'visa_price': '0', 'food_price': '0'
              });
    
              this.travelerDataSource = new MatTableDataSource(this.traveler_list);
              this.travelerDataSource.sort = this.sort;
    
              this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
    
              // calculate total price
              this.calculateTotalAmount();
            // }
          // }
          
        });
    }
    else {
      if (old_customer_no != '') {
        this.main_trav_info = {};
        travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', old_customer_no);

        if (this.traveler_list[travelIndex]['group_id'] != '0') {
          this.traveler_list[travelIndex]['flag'] = 'delete';
          this.traveler_list[travelIndex]['table_name'] = 'trip_group';
          this.toDelete.push(this.traveler_list[travelIndex]);
        }

        this.traveler_list.splice(travelIndex, 1);
        this.travelerDataSource = new MatTableDataSource(this.traveler_list);
        this.travelerDataSource.sort = this.sort;

        // change total field
        this.calculateTotalAmount();

        this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
      }
    }

  }

  changeDependCount() {
    if (this.invoice_model['customer_no'] != '' && this.invoice_model['customer_no'] != '0')
      this.invoice_model['pass_count'] = String(Number(this.model['depend_count']) + 1);
    else
      this.invoice_model['pass_count'] = String(Number(this.model['depend_count']));

    this.showTravelerTable = (Number(this.model['depend_count']) == 0 || (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '1') || this.trip_info['price_type'] != 'room');

    if (!this.showTravelerTable)
      this.visaDisplayedColumns = ['country_name', 'count', 'amount', 'edit', 'del'];
  }

  onChangeDepend = function (search_result: object) {
    let trav_exist = false;
    this.trip_trav_list.forEach(element => {
      if (search_result['no'] == element.member_id)
        trav_exist = true;
    });

    if (trav_exist) {
      alert(this.Trav_Exist_Msg);
      (document.getElementById('search_value_3') as HTMLInputElement).value = '';
      return;
    }

    this.model['depend_no'] = search_result['no'];
  }

  //------------------------------------------------//


  //-------********************** EDIT **********************-------//

  getRegOnTrip() {
    let obj = { cmd: 'getContractDetail', invoice_no: this.no };

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          //------------------------ Invoice ------------------------//
          let invoice_info = result['invoice_info'];

          this.invoice_model = {
            'table_name': 'invoice', 'invoice_id': invoice_info['invoice_id'],
            'invoice_no': invoice_info['invoice_no'], 'invoice_date': invoice_info['invoice_date'],
            'customer_no': invoice_info['customer_no'], 'customer_name': invoice_info['customer_name'],
            'calc_tax': invoice_info['calc_tax'], 'print_tax': invoice_info['print_tax'],
            'total': invoice_info['total'], 'tax': invoice_info['tax'],
            'discount': invoice_info['discount'], 'rep_emp_no': invoice_info['rep_emp_no'],
            'deliver_date': invoice_info['deliver_date'], 'payment_date': invoice_info['payment_date'],
            'invoice_type': invoice_info['invoice_type'], 'cond_list_id': invoice_info['cond_list_id'],
            'transport_fee': invoice_info['transport_fee'], 'received_by': invoice_info['received_by'],
            'is_paid': invoice_info['is_paid'], 'status': '1',
            'cost_center': invoice_info['cost_center'], 'sales_acct': invoice_info['sales_acct'],
            'acct_number': invoice_info['acct_number'], 'flag': 'update', 'key': 'invoice_id',
            'qutation_no': invoice_info['qutation_no'], 'tax_acct': invoice_info['tax_acct'],
            'trans_acct': invoice_info['trans_acct'], 'payment_method': invoice_info['payment_method'],
            'comment': invoice_info['comment'], 'meter_reading': invoice_info['meter_reading'],
            'worker': invoice_info['worker'], 'group_number': invoice_info['group_number'],
            'trip_id': invoice_info['trip_id'], 'pnr': invoice_info['pnr'],
            'pass_count': invoice_info['pass_count'], 'bed_count': invoice_info['bed_count'],
            'seat_count': invoice_info['seat_count'], 'agent_acct_number': invoice_info['agent_acct_number'], 
            'branch_id': invoice_info['branch_id'], 'store_id': invoice_info['store_id'], 
            'no': invoice_info['no'], 'year': invoice_info['year'],
            'total_no_tax': invoice_info['total_no_tax'], 'invoice_uuid': invoice_info['invoice_uuid']
          };

          if (invoice_info['cond_list_id'] == '0' && this.cond_list_id != '0') 
            this.invoice_model['cond_list_id'] = this.cond_list_id;
  
          this.model['invoice_date'] = new Date(invoice_info['invoice_date']);
          this.model['total_after_discount'] = (Number(this.invoice_model['total']) -
            Number(this.invoice_model['discount'])).toFixed(2);
          this.model['total_amount'] = ((Number(this.invoice_model['total']) -
            Number(this.invoice_model['discount'])) + Number(this.invoice_model['tax'])).toFixed(2);
          this.model['old_total_amount'] = Number(((Number(this.invoice_model['total']) -
            Number(this.invoice_model['discount'])) + Number(this.invoice_model['tax'])).toFixed(2));
  
          if (this.trip_info['tax_type'] == 'part_price') {
            this.model['taxable_price'] = ((Number(this.invoice_model['total']) - Number(this.invoice_model['total_no_tax'])) / Number(this.invoice_model['pass_count'])).toFixed(2);
            this.model['price_w_tax'] = (Number(this.invoice_model['total']) - Number(this.invoice_model['total_no_tax'])).toFixed(2);
          }
  
          this.model['depend_count'] = String(Number(this.invoice_model['pass_count']) - 1);


          //------------------------ Invoice Item ------------------------//
          let invoice_item = result['invoice_item'];
          let total = 0;

          invoice_item.forEach(element => {
            element.flag = 'delete';
            element.table_name = 'invoice_item';
            this.toDelete.push(element);

            if (element.type == 'pa') {
              // this.addition_inv_item = element; ext_amount_no_tax
              this.model['ext_amount'] = String(Number(element.price) + Number(element.tax_amount));
              this.model['ext_amount_no_tax'] = String(Number(element.price));
              this.model['amount_comment'] = (element.sub_item_name != null ? element.sub_item_name : '');
            }
            else if (element.type == 'ps') {
              this.model['seat_total'] = (Number(element.price) * Number(element.count)).toFixed(2);
              total += (Number(element.price) * Number(element.count));
            }
            else if (element.type == 'pb') {
              this.model['bed_total'] = (Number(element.price) * Number(element.count)).toFixed(2);
              total += (Number(element.price) * Number(element.count));
            }
          });


          //------------------------ Payment Method ------------------------//
          if (result['payment_method'].length > 0) {
            let inv_payment_method = result['payment_method'][0];
            this.inv_payment_model['inv_payment_method_id'] = inv_payment_method['inv_payment_method_id'];
            this.inv_payment_model['flag'] = 'update';
          }
          
         
          //------------------------ Trip Group ------------------------//
          let trip_group = result['trip_group'];
          
          if (trip_group.length > 1) {
            this.model['chx_addDepend'] = '1';
            (document.getElementById('chx_addDepend') as HTMLInputElement).checked = true;
          }
          this.showTravelerTable = (Number(this.model['depend_count']) == 0 || (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '1') || this.trip_info['price_type'] != 'room');
          if (!this.showTravelerTable)
            this.visaDisplayedColumns = ['country_name', 'count', 'amount', 'edit', 'del'];

          let birthdate, arrivaldate, timeDiff, age;

          trip_group.forEach(element => {
            birthdate = new Date(element['date_of_birth']);
            arrivaldate = new Date(element.trip_arrival_date);
            timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());  // 10/26/2023 Date.now() 
            // timeDiff = Math.abs(Date.now() - birthdate.getTime());
            age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

            total += Number(element.price);

            if (element.head_id == element.member_id) {
              this.main_trav_info = element;
              this.mainTraveler = element['acct_number'] + '-' + element['customer_name'] + '-' +
                element['customer_name_en'] + '-' + element['mobile'];
              
              (document.getElementById('search_value_2') as HTMLInputElement).disabled = true;

              this.traveler_list.unshift({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'customer_name_en': element['customer_name_en'] + " " + element['customer_last_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'رئيسي', 'comment': element.group_comment,
                'type': 'main', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.traveler_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'flag': 'update', 'key': 'group_id',
                'invoice_no': this.no, 'table_name': 'trip_group', 'bed_count': element.bed_count,
                'ticket_count': element.ticket_count, 'visa_price': element.visa_price, 'food_price': element.food_price
              });
            }
            else {
              this.add_depend_list.push({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'customer_name_en': element['customer_name_en'] + " " + element['customer_last_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'تابع', 'comment': element.group_comment,
                'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.add_depend_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'invoice_no': this.no,
                'table_name': 'trip_group', 'visa_price': element.visa_price, 'food_price': element.food_price
              });

              this.traveler_list.push({
                'acct_number': element['acct_number'], 'customer_name': element['customer_name'],
                'national_id': element['national_id'], 'mobile': element['mobile'],
                'passport_no': element['passport_no'], 'traveler_type': 'تابع',
                'comment': element.group_comment, 'flag': 'update', 'key': 'group_id',
                'type': 'depend', 'age': age, 'relative_relation': element.member_head_relation,
                'index': this.traveler_list.length, 'departure_date': element.trip_depart_date,
                'arrival_date': element.trip_arrival_date, 'room_type_id': element.room_type_id,
                'price': element.price, 'group_id': element.group_id, 'invoice_no': this.no,
                'bed_count': element.bed_count, 'ticket_count': element.ticket_count,
                'visa_price': element.visa_price, 'food_price': element.food_price
              });
            }
          });

          this.dependDataSource = new MatTableDataSource(this.add_depend_list);
          this.dependDataSource.sort = this.sort;

          this.travelerDataSource = new MatTableDataSource(this.traveler_list);
          this.travelerDataSource.sort = this.sort;

          this.model['room_total_amount'] = total.toFixed(2);


          //------------------------ Reg on Hotel ------------------------//
          let reg_on_hotel = result['reg_on_hotel'];

          reg_on_hotel.forEach(element => {
            if (this.trip_info['price_type'] == 'room') {
              if (Number(element.bed_num) > 0)
                element.amount = String(Number(element.room_price) * Number(element.bed_num) * Number(element.count));
              else 
                element.amount = String(Number(element.room_price) * Number(element.count));
            }

            if (!this.showTravelerTable) {
              this.add_room_list.push({
                'room_type': element.room_type, 'count': element.count, 'amount': element.amount,
                'index': this.add_room_list.length, 'room_type_id': element.room_type_id,
                'flag': 'update', 'key': 'reg_id', 'reg_id': element.reg_id, 'invoice_no': this.no,
                'room_price': element.room_price, 'room_tax_amount': element.room_tax_amount,
                'table_name': 'reg_on_hotel', 'hotel_name': element.hotel_name,
                'city_id': element.city_id, 'hotel_id': element.hotel_id,
                'room_cost': element.room_cost, 'package': '', 'tax_no': element.tax_no,
                'tax_type': element.tax_type, 'checkin_date': element.checkin_date, 
                'checkout_date': element.checkout_date, 'bed_num': element.bed_num
              });
            }
            else {
              this.add_hotel_list.push({
                'room_type': element.room_type, 'count': element.count, 'amount': element.amount,
                'index': this.add_hotel_list.length, 'room_type_id': element.room_type_id,
                'flag': 'update', 'key': 'reg_id', 'reg_id': element.reg_id, 'invoice_no': this.no,
                'room_price': element.room_price, 'room_tax_amount': element.room_tax_amount,
                'table_name': 'reg_on_hotel', 'hotel_name': element.hotel_name,
                'city_id': element.city_id, 'hotel_id': element.hotel_id,
                'room_cost': element.room_cost, 'package': '', 'tax_no': element.tax_no,
                'tax_type': element.tax_type, 'checkin_date': element.checkin_date, 
                'checkout_date': element.checkout_date, 'trip_hotel_id': element.trip_hotel_id
              });
            }

            if (!this.showTravelerTable) {
              this.roomDataSource = new MatTableDataSource(this.add_room_list);
              this.roomDataSource.sort = this.sort;
            }
            else {
              this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
              this.hotelDataSource.sort = this.sort;
            }
          });


          //------------------------ Reg on Visa ------------------------//
          let reg_on_visa = result['reg_on_visa'];
          if (reg_on_visa.length > 0)
            this.showVisaDetail = true;

          reg_on_visa.forEach(element => {
            this.add_visa_list.push({
              'table_name': 'reg_on_visa', 'reg_visa_id': element.reg_visa_id, 'invoice_no': this.no,
              'visa_tax_amount': element.visa_tax_amount, 'country_id': element.country_id,
              'country_name': element.country_name, 'visa_count': element.visa_count, 
              'visa_price': element.visa_price, 'visa_cost': element.visa_cost, 
              'visa_total': (Number(element.visa_price) * Number(element.visa_count)).toFixed(2), 
              'tax_no': element.tax_no, 'tax_type': element.tax_type, 'flag': 'update', 'key': 'reg_visa_id', 
              'comment': element.comment, 'index': this.add_visa_list.length
            });
          });

          this.visaDataSource = new MatTableDataSource(this.add_visa_list);
          this.visaDataSource.sort = this.sort;


          //------------------------ Reg on Bus ------------------------//
          let reg_on_bus = result['reg_on_bus'];

          reg_on_bus.forEach(element => {
            this.add_bus_list.push({
              'table_name': 'reg_on_bus', 'reg_bus_id': element.reg_bus_id, 'trip_bus_id': element.trip_bus_id,
              'bus_id': element.bus_id, 'depart_date': element.depart_date, 'return_date': element.return_date,
              'flag': 'update', 'key': 'reg_bus_id', 'from_city': element.from_city, 'to_city': element.to_city,
              'invoice_no': this.no, 'comment': element.comment, 'male_seat_count': element.male_seat_count, 
              'female_seat_count': element.female_seat_count, 'addition_count': element.addition_count, 
              'seat_price': element.seat_price, 'seat_cost': element.seat_cost, 
              'tax_type': element.tax_type, 'tax_no': element.tax_no, 'seat_part_price': element.seat_part_price,
              'seat_tax_amount': element.seat_tax_amount, 'from_city_name': element.from_city_name,
              'from_city_name_en': element.from_city_name_en, 'to_city_name': element.to_city_name,
              'to_city_name_en': element.to_city_name_en, 'bus_no': element.bus_no,
              'index': this.add_bus_list.length
            });
          });

          this.busDataSource = new MatTableDataSource(this.add_bus_list);
          this.busDataSource.sort = this.sort;

          // check if there is cash receipt for this invoice
          this.model['has_cash_receipt'] = result['has_cash_receipt'];
        }
      });
  }

  //-------********************** GENERAL FUNCTIONS **********************-------//


  newTraveler() {
    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success') 
        //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
      });
  }

  //------------------------ Calculating Prices ------------------------//

  calc_total_amount() {
    let total = 0, tax = 0;
    let total_amount = 0;

    total = Number(this.model['room_total_amount']);

    // additional amount without tax
    if (this.trip_info['tax_type'] == 'all_price') {
      if (this.trip_tax['tax_perc'] != '0') 
        this.model['ext_amount_no_tax'] = (Number(this.model['ext_amount']) / (1 + (Number(this.trip_tax['tax_perc']) / 100))).toFixed(2);
      else
        this.model['ext_amount_no_tax'] = (Number(this.model['ext_amount']) - this.trip_tax['tax_amount']).toFixed(2);

      total += Number(this.model['ext_amount_no_tax']);
    }
    else {
      total += Number(this.model['ext_amount']);
      this.model['ext_amount_no_tax'] = this.model['ext_amount'];
    }

    this.invoice_model['total'] = total.toFixed(2);
    if (Number(this.invoice_model['discount']) > total)
      this.invoice_model['discount'] = this.invoice_model['total'];

    let total_after_discount = total - Number(this.invoice_model['discount']);
    console.log(total_after_discount.toFixed(2));
    this.model['total_after_discount'] = Number(total_after_discount.toFixed(2)).toString();

    // calculate tax
    if (this.trip_info['tax_type'] == 'all_price') {
      if (this.trip_tax['tax_perc'] != '0')
        tax = (total - Number(this.invoice_model['discount'])) * (Number(this.trip_tax['tax_perc']) / 100);
      else
        tax = this.trip_tax['tax_amount'];

      this.invoice_model['tax'] = tax.toFixed(2);
    }

    else if (this.trip_info['tax_type'] == 'part_price') {
      this.model['taxable_price'] = (this.trip_info['price_for_tax'] == '' ? '0' : this.trip_info['price_for_tax']);
      
      if (this.showTravelerTable) 
        this.model['price_w_tax'] = (Number(this.model['taxable_price']) * Number(this.invoice_model['pass_count'])).toFixed(2);
      else {
        let bed_count = 0;
        this.add_room_list.forEach(element => {

          if (Number(element.bed_num) > 0) 
            bed_count += Number(element.count) * Number(element.bed_num);
        });

        this.model['price_w_tax'] = (Number(this.model['taxable_price']) * bed_count).toFixed(2);
      }
      
      if (this.trip_tax['tax_perc'] != '0') {
        let part_tax_amount = 0;
        part_tax_amount = (Number(this.model['taxable_price']) * (Number(this.trip_tax['tax_perc']) / 100));
        this.invoice_model['tax'] = (part_tax_amount * Number(this.invoice_model['pass_count'])).toFixed(2);
        this.invoice_model['total_no_tax'] = (Number(this.invoice_model['total']) - Number(this.model['price_w_tax'])).toFixed(2);
      }
      else
        this.invoice_model['tax'] = this.trip_tax['tax_amount'];
    }

    // calculate total amount
    total_amount = (total - Number(this.invoice_model['discount'])) + Number(this.invoice_model['tax']);
    this.model['total_amount'] = Number(total_amount.toFixed(2)).toString();
  }

  changeTraveler(acct_number) {
    
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', acct_number);

    this.traveler_list[travelIndex].bed_count =  (this.trip_info['price_type'] == 'age' && (document.getElementById('bed_' + acct_number) as HTMLInputElement).checked ? '1' : '0');
    this.traveler_list[travelIndex].ticket_count = ((document.getElementById('ticket_' + acct_number) as HTMLInputElement).checked ? '1' : '0');

    let departure_date = (document.getElementById('departure_date_' + acct_number) as HTMLInputElement).value;
    this.traveler_list[travelIndex].departure_date = departure_date.substring(6, 11) + '-' +
      departure_date.substring(3, 5) + '-' + departure_date.substring(0, 2);

    let arrival_date = (document.getElementById('arrival_date_' + acct_number) as HTMLInputElement).value;
    this.traveler_list[travelIndex].arrival_date = arrival_date.substring(6, 11) + '-' +
      arrival_date.substring(3, 5) + '-' + arrival_date.substring(0, 2);

    this.calcTravelerPrice(acct_number);

    console.log(this.traveler_list[travelIndex].departure_date);
    console.log(this.traveler_list[travelIndex].arrival_date);

  }

  calcTravelerPrice(acct_number) {
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', acct_number);
    let amount = 0;

    //calculate room price:
    if (this.trip_info['price_type'] == 'room') {

      let room_type_id = (document.getElementById('room_type_' + acct_number) as HTMLInputElement).value;
      this.traveler_list[travelIndex].room_type_id = room_type_id;

      this.room_list.forEach(element => {
        if (element.room_type_id == room_type_id) {
          amount = Number(element.room_price);
        }
      });
    }

    //calculate bed price
    else if (this.trip_info['price_type'] == 'age') {
      let bed = (document.getElementById('bed_' + acct_number) as HTMLInputElement);

      this.trip_age_price.forEach(element => {
        if (this.traveler_list[travelIndex].age >= element.period_from && this.traveler_list[travelIndex].age < element.period_to) {
          if (bed.checked) {
            amount += Number(element.price_bed);
            this.traveler_list[travelIndex].bed_count = '1';
          }
          else
            amount += Number(element.price_no_bed);
        }

      });
    }

    //calculate visa price:
    let visa_req = (document.getElementById('visa_req_' + acct_number) as HTMLInputElement);
    if (visa_req.checked) {
      amount += Number(this.trip_info['visa_price']);
      this.showVisaDetail = true;
      this.traveler_list[travelIndex].visa_price = this.trip_info['visa_price'];
    }
    else 
      this.traveler_list[travelIndex].visa_price = '0';


    if (this.showVisaDetail)
      this.calc_visa_count();

    //calculate food price:
    let food = (document.getElementById('food_' + acct_number) as HTMLInputElement);
    if (food.checked) {
      amount += Number(this.trip_info['food_price']);
      this.traveler_list[travelIndex].food_price = this.trip_info['food_price'];
    }
    else 
      this.traveler_list[travelIndex].food_price = '0';

    this.traveler_list[travelIndex].price = amount.toFixed(2);

    // calculate total price
    this.calculateTotalAmount();
  }

  calculateTotalAmount() {
    // calculate total price
    let total = 0;
    this.traveler_list.forEach(element => {
      total += Number(element.price);
    });

    total += Number(this.model['seat_total']);
    total += Number(this.model['bed_total']);
    this.model['room_total_amount'] = total.toFixed(2);
    console.log(this.traveler_list);

    // reset total field
    this.resetTotal();
  }

  resetTotal() {
    this.model['total_after_discount'] = '0';
    this.invoice_model['tax'] = '0';
    this.model['total_amount'] = '0';
  }

  calc_seat_price() {
    this.model['seat_total'] = (Number(this.trip_info['seat_price']) * Number(this.invoice_model['seat_count'])).toFixed(2);
    
    if (this.showTravelerTable)
      this.calculateTotalAmount();
    else
      this.calculateTotal();
  }

  calc_bed_price() {
    this.model['bed_total'] = (Number(this.trip_info['bed_price']) * Number(this.invoice_model['bed_count'])).toFixed(2);
    
    if (this.showTravelerTable)
      this.calculateTotalAmount();
    else
      this.calculateTotal();
  }

  calc_room_price() {
    let amount = 0;
    let calculate = true;

    if (this.hotel_room_list.length > 0) {
      // get the available room
      let obj = { cmd: 'getAvailHotelRoom', hotel_id: this.hotel_model.hotel_id, arrival_date: this.hotel_model['checkin_date'], 
        depart_date: this.hotel_model['checkout_date'], room_type_id: this.hotel_model.room_type_id };
      if (this.invoice_model['invoice_no'] != '0')
        obj['invoice_no'] = this.invoice_model['invoice_no'];

      this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          this.avail_room_count = data.status['msg'][0]['room_count'];

          if (this.avail_room_count >= Number(this.hotel_model['count']))
            calculate = true;
          else {
            // show alert message
            alert(this.Avail_Room_Count_Msg);
            this.hotel_model['count'] = '0';
            calculate = false;
          } 
        }
      });
    }

    if (calculate && this.hotel_model['room_type_id'] != '0' && Number(this.hotel_model['count']) > 0) {
      this.room_list.forEach(element => {
        if (element.room_type_id == this.hotel_model['room_type_id']) {
          if (Number(element.bed_num) > 0)
            amount = Number(element.room_price) * (Number(element.bed_num) * Number(this.hotel_model['count']));
          else
            amount = Number(element.room_price) * Number(this.hotel_model['count']);
            
          this.hotel_model['amount'] = amount.toFixed(2);
          this.hotel_model['bed_num'] = element.bed_num;
        }
      });
    }
  }

  calc_visa_count() {
    let count = 0;
    this.traveler_list.forEach(element => {
      let visa_req = (document.getElementById('visa_req_' + element.acct_number) as HTMLInputElement);
      if (visa_req.checked)
        count++

      this.visa_model['visa_count'] = String(count);
      if (count == 0)
        this.showVisaDetail = false;
      else
        this.showVisaDetail = true;

    });
  }

  calc_part_tax() {
  
    this.model['taxable_price'] = (Number(this.model['price_w_tax']) / Number(this.invoice_model['pass_count'])).toFixed(2);
    this.resetTotal();
  }

  //------------------------ Check Boxes Change ------------------------//

  changeAddDepent() {
    this.model['chx_addDepend'] = ((document.getElementById('chx_addDepend') as HTMLInputElement).checked ? '1' : '0');
    this.showTravelerTable = (Number(this.model['depend_count']) == 0 || (Number(this.model['depend_count']) > 0 && this.model['chx_addDepend'] == '1') || this.trip_info['price_type'] != 'room');

    this.add_depend_list = [];
  }

  //-------********************** DEPENDENT FUNCTIONS **********************-------//

  addDepend() {
    if (this.model['depend_no'] == '' || this.model['depend_no'] == '0') {
      alert(this.Depend_Msg);
      return;
    }

    let query = "SELECT `customer`.*, `traveler_info`.* FROM `customer`," +
      " `traveler_info` WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = `traveler_info`.`acct_number`" +
      " AND `customer`.`acct_number` = '" + this.model['depend_no'] + "'";

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let depend_info = data.data['list'][0];

        let birthdate = new Date(depend_info['date_of_birth']);
        let arrivaldate = new Date(this.trip_info['arrival_date']);
        let timeDiff = Math.abs(arrivaldate.getTime() - birthdate.getTime());  // 10/26/2023 Date.now() 
        // let timeDiff = Math.abs(Date.now() - birthdate.getTime());
        let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);

        let price = 0;
        if (this.trip_info['price_type'] == 'age') {
          this.trip_age_price.forEach(element => {
            if (age >= element.period_from && age < element.period_to) {
              price = Number(element.price_bed);
            }
          });
        }

        this.add_depend_list.push({
          'acct_number': depend_info['acct_number'], 'customer_name': depend_info['customer_name'],
          'national_id': depend_info['national_id'], 'mobile': depend_info['mobile'],
          'passport_no': depend_info['passport_no'], 'traveler_type': 'تابع', 'comment': this.group_model['comment'],
          'type': 'depend', 'age': age, 'relative_relation': '', 'index': this.add_depend_list.length,
          'departure_date': '', 'arrival_date': '', 'room_type_id': '', 'price': price.toFixed(2)
        });

        this.dependDataSource = new MatTableDataSource(this.add_depend_list);
        this.dependDataSource.sort = this.sort;

        this.traveler_list.push({
          'table_name': 'trip_group', 'acct_number': depend_info['acct_number'],
          'customer_name': depend_info['customer_name'], 'national_id': depend_info['national_id'],
          'mobile': depend_info['mobile'], 'passport_no': depend_info['passport_no'], 'traveler_type': 'تابع',
          'comment': this.group_model['comment'], 'flag': 'new', 'key': 'group_id',
          'type': 'depend', 'age': age, 'relative_relation': '', 'index': this.traveler_list.length,
          'departure_date': this.trip_info['departure_date'], 'arrival_date': this.trip_info['arrival_date'],
          'room_type_id': '', 'price': price.toFixed(2), 'invoice_no': this.invoice_model['invoice_no'],
          'group_id': '0', 'bed_count': '1', 'ticket_count': '1', 'visa_price': '0', 'food_price': '0'
        });

        this.travelerDataSource = new MatTableDataSource(this.traveler_list);
        this.travelerDataSource.sort = this.sort;

        (document.getElementById('search_value_3') as HTMLInputElement).value = '';
        this.group_model['comment'] = '';

        // calculate total price
        this.calculateTotalAmount();
      });
  }

  changeRelation(event, acct_number) {
    let value = event.srcElement.value;
    let dependIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', acct_number);
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', acct_number);

    this.add_depend_list[dependIndex].relative_relation = value;
    this.traveler_list[travelIndex].relative_relation = value;
  }

  deleteDepend(row) {
    let dependIndex = this.utils.getDPIndex(this.add_depend_list, 'acct_number', row.acct_number);
    let travelIndex = this.utils.getDPIndex(this.traveler_list, 'acct_number', row.acct_number);

    if (row.group_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_depend_list.splice(dependIndex, 1);
    this.dependDataSource = new MatTableDataSource(this.add_depend_list);
    this.dependDataSource.sort = this.sort;


    this.traveler_list.splice(travelIndex, 1);
    this.travelerDataSource = new MatTableDataSource(this.traveler_list);
    this.travelerDataSource.sort = this.sort;

    // change total field
    this.calculateTotalAmount();
  }

  next(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_next1")
      this.selectedTab = 1;
    else if (btnId == "btn_next2")
      this.selectedTab = 2;
    else if (btnId == "btn_next3")
      this.selectedTab = 3;
  }

  back(event) {
    let btnId = event.srcElement.id;

    if (btnId == "btn_back0")
      this.selectedTab = 0;
    else if (btnId == "btn_back1")
      this.selectedTab = 1;
    else if (btnId == "btn_back2")
      this.selectedTab = 2;
  }

  //-------********************** ROOM FUNCTIONS **********************-------//

  add_room() {
    if (this.hotel_model['trip_hotel_id'] == '0') {
      alert(this.Hotel_Msg);
      return;
    }

    if (this.hotel_model['room_type_id'] == '0') {
      alert(this.Room_Type_Msg);
      return;
    }

    this.room_list.forEach(element => {
      if (element.room_type_id == this.hotel_model['room_type_id']) {
        this.hotel_model['room_type'] = element.room_type;
        this.hotel_model['room_price'] = element.room_price;
        this.hotel_model['room_cost'] = element.room_cost;
        this.hotel_model['room_tax_amount'] = element.room_tax_amount;
      }
    });
    console.log(this.hotel_list);
    this.hotel_list.forEach(element => {
      if (element.trip_hotel_id == this.hotel_model['trip_hotel_id']) {
        this.hotel_model['hotel_id'] = element.hotel_id;
        this.hotel_model['city_id'] = element.city_id;
        this.hotel_model['checkin_date'] = element.arrival_date;
        this.hotel_model['checkout_date'] = element.depart_date;
        this.hotel_model['hotel_name'] = element.hotel_name
      }
    });

    let index;
    if (this.hotel_model['reg_id'] == '0') {
      let room_existed = false;

      for (index = 0; index < this.add_room_list.length; index++) {
        if (this.add_room_list[index].room_type_id == this.hotel_model['room_type_id'] && 
          this.add_room_list[index].hotel_id == this.hotel_model['hotel_id'] && 
          this.add_room_list[index].checkin_date == this.hotel_model['checkin_date'] && 
          this.add_room_list[index].checkout_date == this.hotel_model['checkout_date']) {
          this.add_room_list[index] = this.hotel_model;
          room_existed = true;
          break;
        }
      }

      if (!room_existed) {
        this.hotel_model['index'] = this.add_room_list.length;
        this.add_room_list.push(this.hotel_model);
      }
    }
    else {
      for (index = 0; index < this.add_room_list.length; index++) {
        if (this.add_room_list[index].room_type_id == this.hotel_model['room_type_id'] && 
          this.add_room_list[index].hotel_id == this.hotel_model['hotel_id'] && 
          this.add_room_list[index].checkin_date == this.hotel_model['checkin_date'] && 
          this.add_room_list[index].checkout_date == this.hotel_model['checkout_date']) {

          this.add_room_list[index] = this.hotel_model;
          break;
        }
      }
    }

    this.roomDataSource = new MatTableDataSource(this.add_room_list);
    this.roomDataSource.sort = this.sort;

    this.calculateTotal();


    this.hotel_model = {
      'table_name': 'reg_on_hotel', 'reg_id': '0', 'invoice_no': '', 'room_type_id': '0', 'count': '',
      'flag': 'new', 'key': 'reg_id', 'comment': '', 'city_id': '0', 'hotel_id': '0',
      'room_price': '', 'room_cost': '0', 'package': '', 'room_type': '', 'hotel_name': '', 'tax_no': '',
      'tax_type': '', 'room_tax_amount': '', 'checkin_date': '', 'checkout_date': '', 'index': 0,
      'amount': '', 'trip_hotel_id': '0'
    }
  }

  calculateTotal() {
    // calculate total price
    let total = 0;
    this.add_room_list.forEach(room => {
      total += Number(room.amount);
    });

    if (!this.showTravelerTable) {
      this.add_visa_list.forEach(visa => {
        total += Number(visa.visa_total);
      });
    }

    total += Number(this.model['seat_total']);
    total += Number(this.model['bed_total']);
    this.model['room_total_amount'] = total.toFixed(2);

    this.resetTotal();
  }

  // calculateTax(amount, inputId) {
  //   // calculate total tax
  //   let total_tax = 0;
  //   if (this.trip_info['tax_type'] == 'all_price') {
  //     if (this.trip_tax['tax_perc'] != '0')
  //       total_tax = amount * (Number(this.trip_tax['tax_perc']) / 100);
  //     else
  //       total_tax = this.trip_tax['tax_amount'];
  //   }
  //   (document.getElementById(inputId) as HTMLInputElement).value = total_tax.toFixed(2);
  // }

  editRoom(row) {
    this.hotel_model = row;
    console.log(this.hotel_model);
  }

  deleteRoom(row) {
    let roomIndex = this.utils.getDPIndex(this.add_room_list, 'index', row.index);

    if (row.reg_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_room_list.splice(roomIndex, 1);
    this.roomDataSource = new MatTableDataSource(this.add_room_list);
    this.roomDataSource.sort = this.sort;

    this.calculateTotal();
  }

  //-------********************** VISA FUNCTIONS **********************-------//

  add_visa() {
    if (this.visa_model['country_id'] == '0') {
      alert(this.Country_Msg);
      return;
    }

    this.country_list.forEach(element => {
      if (element.country_id == this.visa_model['country_id'])
        this.visa_model['country_name'] = element.country_name;
    });

    if (this.visa_model['reg_visa_id'] == '0') {
      let visa_existed = false;
      this.add_visa_list.forEach(element => {
        if (element.country_id == this.visa_model['country_id']) {
          element = this.visa_model;
          visa_existed = true;
        }
      });

      if (!visa_existed) {
        this.visa_model['index'] = this.add_visa_list.length;
        this.visa_model['visa_price'] = this.trip_info['visa_price'];
        this.add_visa_list.push(this.visa_model);
      }
    }
    else {
      this.add_visa_list.forEach(element => {
        if (element.country_id == this.visa_model['country_id']) {
          element = this.visa_model;
        }
      });
    }

    this.visaDataSource = new MatTableDataSource(this.add_visa_list);
    this.visaDataSource.sort = this.sort;

    if (!this.showTravelerTable)
      this.calculateTotal();

    this.visa_model = {
      'table_name': 'reg_on_visa', 'reg_visa_id': '0', 'invoice_no': '', 'visa_tax_amount': '0',
      'country_id': '0', 'country_name': '', 'visa_count': '', 'visa_price': '0', 'visa_cost': '0',
      'visa_total': '0', 'tax_no': '', 'tax_type': '', 'taxable_price': '0', 'tax': '0', 'total_amount': '',
      'flag': 'new', 'key': 'reg_visa_id', 'comment': '', 'visa_tax': '0', 'final_total': '', 'index': 0
    }
  }

  editVisa(row) {
    this.visa_model = row;
  }

  deleteVisa(row) {
    let visaIndex = this.utils.getDPIndex(this.add_visa_list, 'index', row.index);

    if (row.reg_visa_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_visa_list.splice(visaIndex, 1);
    this.visaDataSource = new MatTableDataSource(this.add_visa_list);
    this.visaDataSource.sort = this.sort;
  }

  calc_visa_price() {
    this.visa_model['visa_total'] = (Number(this.trip_info['visa_price']) * Number(this.visa_model['visa_count'])).toFixed(2);
  }

  //-------********************** HOTEL FUNCTIONS **********************-------//

  getHotelRoom() {
    if (this.hotel_room_list.length > 0) {

      // fill hotel room type list based on selected hotel
      for (let index = 0; index < this.hotel_list.length; index++) {
        if (this.hotel_list[index]['trip_hotel_id'] == this.hotel_model['trip_hotel_id']) {
          this.hotel_model['hotel_id'] = this.hotel_list[index]['hotel_id'];
          this.hotel_model['checkin_date'] = this.hotel_list[index]['arrival_date'];
          this.hotel_model['checkout_date'] = this.hotel_list[index]['depart_date'];
          break;
        }
      }

      this.hotel_room_list.forEach(element => {
        if (element.hotel_id == this.hotel_model['hotel_id'] && element.arrival_date == this.hotel_model['checkin_date'] && 
          element.depart_date == this.hotel_model['checkout_date']) {
          this.hotel_room_type.push(Object.assign({}, element));
        }
      });
      this.hotel_room_list.unshift({ 'room_type_id': '0', 'room_type': 'اختر/ Select' });
    }
  }

  add_hotel() {
    if (this.hotel_model['room_type_id'] == '0') {
      alert(this.Room_Type_Msg);
      return;
    }

    if (this.hotel_model['trip_hotel_id'] == '0') {
      alert(this.Hotel_Msg);
      return;
    }
    console.log(this.hotel_model);
    this.room_list.forEach(element => {
      if (element.room_type_id == this.hotel_model['room_type_id']) {
        this.hotel_model['room_type'] = element.room_type;
        this.hotel_model['room_price'] = element.room_price;
        this.hotel_model['room_cost'] = element.room_cost;
        this.hotel_model['room_tax_amount'] = element.room_tax_amount;
      }
    });

    this.hotel_list.forEach(element => {
      if (element.trip_hotel_id == this.hotel_model['trip_hotel_id']) {
        this.hotel_model['hotel_id'] = element.hotel_id;
        this.hotel_model['city_id'] = element.city_id;
        this.hotel_model['checkin_date'] = element.arrival_date;
        this.hotel_model['checkout_date'] = element.depart_date;
        this.hotel_model['hotel_name'] = element.hotel_name
      }
    });


    if (this.hotel_model['reg_id'] == '0') {
      let room_existed = false;
      this.add_hotel_list.forEach(element => {
        if (element.room_type_id == this.hotel_model['room_type_id'] && element.hotel_id == this.hotel_model['hotel_id'] && 
          element.checkin_date == this.hotel_model['checkin_date'] && 
          element.checkout_date == this.hotel_model['checkout_date']) {

          element = this.hotel_model;
          room_existed = true;
        }
      });

      if (!room_existed) {
        this.hotel_model['index'] = this.add_hotel_list.length;
        this.add_hotel_list.push(this.hotel_model);
      }
    }
    else {
      this.add_hotel_list.forEach(element => {
        if (element.room_type_id == this.hotel_model['room_type_id'] && element.hotel_id == this.hotel_model['hotel_id'] && 
          element.checkin_date == this.hotel_model['checkin_date'] && 
          element.checkout_date == this.hotel_model['checkout_date']) {
            
          element = this.hotel_model;
        }
      });
    }

    this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.hotelDataSource.sort = this.sort;

    // this.calculateTotal();

    this.hotel_model = {
      'table_name': 'reg_on_hotel', 'reg_id': '0', 'invoice_no': '', 'room_type_id': '0', 'count': '',
      'flag': 'new', 'key': 'reg_id', 'comment': '', 'city_id': '0', 'hotel_id': '0',
      'room_price': '', 'room_cost': '', 'package': '', 'room_type': '', 'hotel_name': '', 'tax_no': '',
      'tax_type': '', 'room_tax_amount': '', 'checkin_date': '', 'checkout_date': '', 'index': 0,
      'amount': '', 'trip_hotel_id': '0'
    }
  }

  editHotel(row) {
    this.hotel_model = row;
    console.log(this.hotel_model);
  }

  deleteHotel(row) {
    let roomIndex = this.utils.getDPIndex(this.add_hotel_list, 'index', row.index);

    if (row.reg_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_hotel_list.splice(roomIndex, 1);
    this.hotelDataSource = new MatTableDataSource(this.add_hotel_list);
    this.hotelDataSource.sort = this.sort;

    // this.calculateTotal();
  }


  //-------********************** BUS FUNCTIONS **********************-------//

  add_bus() {
    if (this.bus_model['trip_bus_id'] == '0') {
      alert(this.Bus_Msg);
      return;
    }
    console.log(this.bus_model);

    this.bus_list.forEach(element => {
      if (element.trip_bus_id == this.bus_model['trip_bus_id']) {
        this.bus_model['bus_no'] = element.bus_no;

        this.bus_model['bus_id'] = element.bus_id;
        this.bus_model['from_city_name'] = element.from_city_name;
        this.bus_model['from_city_name_en'] = element.from_city_name_en;
        this.bus_model['from_city'] = element.from_city;

        this.bus_model['to_city_name'] = element.to_city_name;
        this.bus_model['to_city_name_en'] = element.to_city_name_en;
        this.bus_model['to_city'] = element.to_city;

        this.bus_model['depart_date'] = element.depart_date;
        this.bus_model['return_date'] = element.return_date;
      }
    });

    if (this.bus_model['reg_bus_id'] == '0') {
      let bus_existed = false;
      this.add_bus_list.forEach(element => {
        if (element.trip_bus_id == this.bus_model['trip_bus_id']) {
          element = this.bus_model;
          bus_existed = true;
        }
      });

      if (!bus_existed) {
        this.bus_model['index'] = this.add_bus_list.length;
        this.bus_model['seat_price'] = this.trip_info['seat_price'];
        this.add_bus_list.push(this.bus_model);
      }
    }
    else {
      this.add_bus_list.forEach(element => {
        if (element.trip_bus_id == this.bus_model['trip_bus_id']) {
          element = this.bus_model;
        }
      });
    }

    this.busDataSource = new MatTableDataSource(this.add_bus_list);
    this.busDataSource.sort = this.sort;

    this.bus_model = {
      'table_name': 'reg_on_bus', 'reg_bus_id': '0', 'trip_bus_id': '0', 'bus_id': '0', 'depart_date': '',
      'return_date': '', 'flag': 'new', 'key': 'reg_bus_id', 'from_city': '0', 'to_city': '0', 'invoice_no': '',
      'comment': '', 'male_seat_count': '0', 'female_seat_count': '0', 'addition_count': '', 'seat_price': '', 'seat_cost': '0',
      'tax_type': '', 'tax_no': '', 'seat_part_price': '0', 'seat_tax_amount': '0', 'from_city_name': '',
      'from_city_name_en': '', 'to_city_name': '', 'to_city_name_en': ''
    }
  }

  editBus(row) {
    this.bus_model = row;
  }

  deleteBus(row) {
    let busIndex = this.utils.getDPIndex(this.add_bus_list, 'index', row.index);

    if (row.reg_bus_id != '0') {
      row.flag = 'delete';
      this.toDelete.push(row);
    }

    this.add_bus_list.splice(busIndex, 1);
    this.busDataSource = new MatTableDataSource(this.add_bus_list);
    this.busDataSource.sort = this.sort;
  }


  //-------********************** SVAE **********************-------//

  add() {
    this.saveClicked = true;

    if (this.invoice_model['customer_no'] == '' || this.invoice_model['customer_no'] == '0') {
      alert(this.Main_Traveler_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['chx_addDepend'] == '1' && Number(this.model['depend_count']) != this.add_depend_list.length) {
      alert(this.Depend_Num_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['total_amount'] == '0') {
      alert(this.Total_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.showTravelerTable) {
      this.pass_count = 0;
      this.traveler_list.forEach(element => {
        if (Number(element.age) >= 2)
          this.pass_count++;
      });
    }
    else 
      this.pass_count = Number(this.invoice_model['pass_count']);
    // console.log('pass_count: ' + this.pass_count);
    let traveler_count = Number(this.registered_count) + this.pass_count;
    if (Number(traveler_count) > Number(this.trip_info['visitors_number'])) {
      alert(this.Reg_Count_Msg);
      this.saveClicked = false;
      return;
    }

    let values = [];
    let obj;

    //------------------------ Invoice ------------------------//
    let invoice_date = this.model['invoice_date'].getFullYear() + "-" + (this.model['invoice_date'].getMonth() + 1) + "-" +
      this.model['invoice_date'].getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' +
      new Date().getSeconds();

    this.invoice_model['invoice_date'] = invoice_date;

    if (this.invoice_model['invoice_id'] == '0') {
      let invoice_uuid = uuidv4();
      this.invoice_model['invoice_uuid'] = invoice_uuid;
      
      this.invoice_model['deliver_date'] = this.invoice_model['invoice_date'];
      this.invoice_model['payment_date'] = this.invoice_model['invoice_date'];

      if (this.applicationConstants.user_info['user_id'] == undefined) {
        this.invoice_model['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];

        if (this.remain_balance < 0 || this.remain_balance < Number(this.model['total_amount'])) {
          alert(this.Agent_Limit_Msg);
          this.saveClicked = false;
          return;
        }
      }
    }
    // else {
    //   if (this.applicationConstants.user_info['user_id'] == undefined) {
    //     this
    //   }
    // }
    
    this.invoice_model['payment_method'] = 'credit';
    this.invoice_model['sales_acct'] = this.revenue_acct_no;
    this.invoice_model['cost_center'] = this.trip_info['cost_center'];

    if (Number(this.invoice_model['tax']) > 0) {
      this.invoice_model['tax_acct'] = String(this.trip_tax['acct_number']);
      this.invoice_model['calc_tax'] = '1';
    }
    values.push(this.invoice_model);


    //------------------------ Payment Method ------------------------//
    this.inv_payment_model['invoice_no'] = this.invoice_model['invoice_no'];
    this.inv_payment_model['acct_number'] = this.invoice_model['customer_no'];
    this.inv_payment_model['amount'] = this.model['total_amount'];
    values.push(this.inv_payment_model);

    let discount = Number(this.invoice_model['discount']);
    let total_price = 0, tax_amount = 0;
    let sub_item_name, item_discount;


    //------------------------ Invoice Item and Traveler ------------------------//
    if (this.showTravelerTable) {
      let index = 0;
      this.traveler_list.forEach(element => {
        sub_item_name = 'تسجيل ' + element.customer_name + ' على الرحلة ' + this.trip_info['trip_name'] +
          " (" + this.trip_info['trip_number'] + ")";

        tax_amount = 0;
        item_discount = 0;
        total_price = Number(element.price);
        if (this.trip_info['tax_type'] != 'part_price') {
          if (discount > 0) {
            if (total_price >= discount)
              item_discount = discount;
            else 
              item_discount = total_price;
          }
        }

        if (this.trip_info['tax_type'] == 'all_price') {
          if (this.trip_tax['tax_perc'] != '0') 
            tax_amount = (total_price - item_discount) * (Number(this.trip_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.trip_tax['tax_amount']);
        }

        values.push({
          'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
          'head_id': this.main_trav_info['acct_number'], 'member_id': element.acct_number,
          'member_head_relation': element.relative_relation, 'is_active': '1', 'group_type': '',
          'trip_arrival_date': element.arrival_date, 'trip_depart_date': element.departure_date, 
          'member_age': element.age, 'eticket': '',
          'ticket_status': '0', 'ticket_count': element.ticket_count, 'bed_count': element.bed_count,
          'price': element.price, 'flag': element.flag, 'key': 'group_id', 'room_type_id': element.room_type_id, 'comment': element.comment,
          'visa_price': element.visa_price, 'food_price': element.food_price
        });

        if (this.trip_info['tax_type'] == 'part_price') {

          // calculate tax on part of price
          total_price = Number(this.model['taxable_price']);
          if (this.trip_tax['tax_perc'] != '0') 
            tax_amount = total_price * (Number(this.trip_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.trip_tax['tax_amount']);

          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
            'sub_item_name': 'رسوم تسجيل ' + element.customer_name + ' على الرحلة ' + 
            this.trip_info['trip_name'] + " (" + this.trip_info['trip_number'] + ")",
            'price': total_price.toFixed(2), 'unit_id': '0', 'count': '1', 'total_price': total_price.toFixed(2),
            'tax_no': this.trip_info['tax_no'], 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.revenue_acct_no
          });
          
          // calculate no tax price
          total_price = Number(element.price) - total_price;
          tax_amount = 0;

          if (discount > 0) {
            if (total_price >= discount)
              item_discount = discount;
            else 
              item_discount = total_price;
          }

          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 'sub_item_name': sub_item_name,
            'price': total_price.toFixed(2), 'unit_id': '0', 'count': '1', 'total_price': total_price.toFixed(2),
            'tax_no': '', 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.revenue_acct_no
          });
        }
        else {
          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
            'sub_item_name': sub_item_name, 'price': total_price.toFixed(2), 'unit_id': '0', 
            'count': '1', 'total_price': total_price.toFixed(2),
            'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 'invoice_item_id': '0', 
            'tax_amount': tax_amount.toFixed(2), 'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 
            'discount': item_discount.toFixed(2), 'stock_no': '0', 'store_id': this.invoice_model['store_id'], 
            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 
            'revenue_acct_no': this.revenue_acct_no
          });
        }

        if (discount > 0) 
          discount -= item_discount;

        index++;
      });

      if (this.invoice_model['invoice_no'] != '0' && this.add_room_list.length > this.traveler_list.length) {
        for (index = this.add_room_list.length - 1; index >= this.traveler_list.length; index--) {
          this.add_room_list[index]['flag'] = 'delete';
          this.toDelete.push(this.add_room_list[index]);
        }
      }
    }
    else {
      let bed_count = 0, taxable_price = 0;
      this.add_room_list.forEach(element => {
        sub_item_name = 'غرفة ' + element.room_type + ' على الرحلة ' + this.trip_info['trip_name'] +
          " (" + this.trip_info['trip_number'] + ")";

        tax_amount = 0;
        item_discount = 0;
    
        total_price = Number(element.count) * Number(element.room_price);
        bed_count = Number(element.count);

        if (Number(element.bed_num) > 0) {
          total_price *= Number(element.bed_num);
          bed_count *= Number(element.bed_num);
        }

        if (this.trip_info['tax_type'] != 'part_price') {
          if (discount > 0) {
            if (total_price >= discount)
              item_discount = discount;
            else 
              item_discount = total_price;
          }
        }

        if (this.trip_info['tax_type'] == 'all_price') {
          if (this.trip_tax['tax_perc'] != '0') 
            tax_amount = (total_price - item_discount) * (Number(this.trip_tax['tax_perc']) / 100);
          else  
            tax_amount = Number(this.trip_tax['tax_amount']);
        }

        values.push({
          'table_name': 'reg_on_hotel', 'reg_id': element.reg_id, 'invoice_no': this.invoice_model['invoice_no'],
          'room_type_id': element.room_type_id, 'flag': element.flag, 'key': 'reg_id',
          'count': element.count, 'comment': element.comment,'city_id': element.city_id, 'hotel_id': element.hotel_id,
          'room_price': element.room_price, 'room_cost': element.room_cost, 'package': '', 'tax_no': '0',
          'tax_type': '', 'room_tax_amount': element.room_tax_amount, 'checkin_date': element.checkin_date, 'checkout_date': element.checkout_date
        });

        if (this.trip_info['tax_type'] == 'part_price') {

          // calculate tax on part of price
          taxable_price = bed_count * Number(this.model['taxable_price']);
          if (this.trip_tax['tax_perc'] != '0') 
            tax_amount = taxable_price * (Number(this.trip_tax['tax_perc']) / 100);
          else 
            tax_amount = Number(this.trip_tax['tax_amount']);

          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
            'sub_item_name': 'رسوم حجز غرفة ' + element.room_type + ' على الرحلة ' + 
            this.trip_info['trip_name'] + " (" + this.trip_info['trip_number'] + ")",
            'price': this.model['taxable_price'], 'unit_id': '0', 'count': bed_count, 
            'total_price': taxable_price.toFixed(2), 'tax_no': this.trip_info['tax_no'], 
            'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.revenue_acct_no
          });
          
          // calculate no tax price
          total_price = total_price - taxable_price;
          tax_amount = 0;

          if (discount > 0) {
            if (total_price >= discount)
              item_discount = discount;
            else 
              item_discount = total_price;
          }

          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 'sub_item_name': sub_item_name,
            'price': (element.room_price - Number(this.model['taxable_price'])).toFixed(2), 
            'unit_id': '0', 'count': bed_count, 'total_price': total_price.toFixed(2),
            'tax_no': '', 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.revenue_acct_no
          });
        }
        else {
          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
            'sub_item_name': sub_item_name, 'price': element.room_price, 'unit_id': '0', 
            'count':bed_count, 'total_price': total_price.toFixed(2), 
            'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
            'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2), 'type': 'p', 'flag': 'new', 
            'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 'stock_no': '0', 
            'store_id': this.invoice_model['store_id'],
            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
            'revenue_acct_no': this.revenue_acct_no
          });
        }

        if (discount > 0) 
          discount -= item_discount;
      
      });

      let element = this.traveler_list[0];
      total_price = Number(this.model['room_total_amount']) - Number(this.model['seat_total']) - 
        Number(this.model['bed_total']);

      values.push({
        'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
        'head_id': this.main_trav_info['acct_number'], 'member_id': element.acct_number,
        'member_head_relation': element.relative_relation, 'is_active': '1', 'group_type': '',
        'trip_arrival_date': this.trip_info['arrival_date'], 'trip_depart_date': this.trip_info['departure_date'],
        'member_age': element.age, 'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': element.bed_count,
        'price': total_price.toFixed(2), 'flag': element.flag, 'key': 'group_id', 'room_type_id': '',
        'comment': element.comment, 'visa_price': element.visa_price, 'food_price': element.food_price
      });
    }

    if (!this.showTravelerTable || this.showVisaDetail) {
      this.add_visa_list.forEach(element => {

        if (!this.showTravelerTable) {
          sub_item_name = "تأشيرة لدولة " + element.country_name + " للرحلة " + this.trip_info['trip_name'] +
            " (" + this.trip_info['trip_number'] + ")";

          tax_amount = 0;
          if (this.trip_info['tax_type'] == 'all_price') {
            if (this.trip_tax['tax_perc'] != '0') {
              tax_amount = Number(element.visa_total) * (Number(this.trip_tax['tax_perc']) / 100);
            }
            else {
              tax_amount = Number(this.trip_tax['tax_amount']);
            }
          }
  
          values.push({
            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
            'sub_item_name': sub_item_name, 'price': this.trip_info['visa_price'], 'unit_id': '0', 
            'count':element.visa_count, 'total_price': element.visa_total, 
            'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
            'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2), 'type': 'pv', 'flag': 'new', 
            'key': 'invoice_item_id', 'discount': '0', 'stock_no': '0', 'store_id': this.invoice_model['store_id'],
            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
            'revenue_acct_no': this.revenue_acct_no
          });
        }

        values.push({
          'table_name': 'reg_on_visa', 'reg_visa_id': element.reg_visa_id, 'invoice_no': this.invoice_model['invoice_no'],
          'visa_tax_amount': element.visa_tax, 'country_id': element.country_id, 'visa_count': element.visa_count,
          'visa_price': element.visa_price, 'visa_cost': element.visa_cost, 'tax_no': element.tax_no,
          'tax_type': element.tax_type, 'flag': element.flag, 'key': 'reg_visa_id', 'comment': '',
          'visa_part_price': element.visa_part_price
        });
      });
    }

    // if (this.showBusBooking) {
    this.add_bus_list.forEach(element => {
      values.push({
        'table_name': 'reg_on_bus', 'reg_bus_id': element.reg_bus_id, 'trip_bus_id': element.trip_bus_id, 
        'bus_id': element.bus_id, 'depart_date': element.depart_date, 'return_date': element.return_date, 
        'flag': element.flag, 'key': 'reg_bus_id', 'from_city': element.from_city, 'to_city': element.to_city, 
        'invoice_no': this.invoice_model['invoice_no'], 'male_seat_count': element.male_seat_count, 
        'female_seat_count': element.female_seat_count, 'addition_count': '0', 'seat_price': element.seat_price,
        'seat_cost': element.seat_cost, 'tax_type': element.tax_type, 'tax_no': element.tax_no,
        'seat_tax_amount': element.seat_tax_amount, 'seat_part_price': element.seat_part_price, 
        'comment': element.comment
      });
    });
    // }

    if (this.showTravelerTable) {
      this.add_hotel_list.forEach(element => {
        values.push({
          'table_name': 'reg_on_hotel', 'reg_id': element.reg_id, 'invoice_no': this.invoice_model['invoice_no'],
          'room_type_id': element.room_type_id, 'flag': element.flag, 'key': 'reg_id',
          'count': element.count, 'comment': element.comment, 'city_id': element.city_id, 'hotel_id': element.hotel_id,
          'room_price': element.room_price, 'room_cost': element.room_cost, 'package': '', 'tax_no': '0',
          'tax_type': '', 'room_tax_amount': element.room_tax_amount, 'checkin_date': element.checkin_date, 'checkout_date': element.checkout_date
        });
      });
    }

    //Extra Amounts:

    if (Number(this.model['ext_amount_no_tax']) > 0 || this.model['amount_comment'] != '') {

      let ext_amount = Number(this.model['ext_amount_no_tax']), ext_amt_tax = 0;
      item_discount = 0;
      if (discount > 0) {
        if (ext_amount >= discount)
          item_discount = discount;
        else 
          item_discount = ext_amount;
      }

      if (this.trip_info['tax_type'] == 'all_price') {
        if (this.trip_tax['tax_perc'] != '0') 
          ext_amt_tax = (ext_amount - item_discount) * (Number(this.trip_tax['tax_perc']) / 100);
        else 
          ext_amt_tax = Number(this.trip_tax['tax_amount']);
      }

      if (discount > 0)
        discount -= item_discount; 

      if (this.model['amount_comment'] == '')
        this.model['amount_comment'] = 'مبالغ إضافية';

      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
        'sub_item_name': this.model['amount_comment'], 'price': ext_amount.toFixed(2),
        'unit_id': '0', 'total_price': ext_amount.toFixed(2), 
        'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''),
        'invoice_item_id': '0', 'tax_amount': ext_amt_tax.toFixed(2), 'type': 'pa', 
        'key': 'invoice_item_id', 'count': '1', 'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0', 
        'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 'primary_quantity': '0',
        'comment': this.model['amount_comment'], 'revenue_acct_no': this.revenue_acct_no
      });
    }

    // Extra Seat:

    if (Number(this.invoice_model['seat_count']) > 0) {

      let ext_seat_tax = 0, ext_seat_price = Number(this.model['seat_total']);
      item_discount = 0;
      if (discount > 0) {
        if (ext_seat_price >= discount)
          item_discount = discount;
        else 
          item_discount = ext_seat_price;

        discount -= item_discount;
      }
    
      if (this.trip_info['tax_type'] == 'all_price') {
        if (this.trip_tax['tax_perc'] != '0') 
          ext_seat_tax = (Number(this.model['seat_total']) - item_discount) * (Number(this.trip_tax['tax_perc']) / 100);
        else 
          ext_seat_tax = Number(this.trip_tax['tax_amount']);
      }

      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
        'sub_item_name': (this.applicationConstants.user_lang == 'ar' ? 'مقاعد إضافية' : 'Additional Seats'), 
        'price': this.trip_info['seat_price'], 'unit_id': '0', 'total_price': this.model['seat_total'], 
        'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
        'invoice_item_id': '0', 'tax_amount': ext_seat_tax.toFixed(2), 
        'type': 'ps', 'key': 'invoice_item_id', 'count': this.invoice_model['seat_count'],
        'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0', 'store_id': this.invoice_model['store_id'], 
        'primary_sub_item_number': '', 'primary_quantity': '0',
        'comment': (this.applicationConstants.user_lang == 'ar' ? 'مقاعد إضافية' : 'Additional Seats'),
        'revenue_acct_no': this.revenue_acct_no
      });
    }

    //Extra Bed:

    if (Number(this.invoice_model['bed_count']) > 0) {

      let ext_bed_tax = 0, ext_bed_price = Number(this.model['bed_total']);
      item_discount = 0;
      if (discount > 0) {
        if (ext_bed_price >= discount)
          item_discount = discount;
        else 
          item_discount = ext_bed_price;

        discount -= item_discount;
      }
      
      if (this.trip_info['tax_type'] == 'all_price') {
        if (this.trip_tax['tax_perc'] != '0') {
          ext_bed_tax = (Number(this.model['bed_total']) - item_discount) * (Number(this.trip_tax['tax_perc']) / 100);
        }
        else {
          ext_bed_tax = Number(this.trip_tax['tax_amount']);
        }
      }

      values.push({
        'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
        'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
        'sub_item_name': (this.applicationConstants.user_lang == 'ar' ? 'أسرة إضافية' : 'Additional Beds'), 
        'price': this.trip_info['bed_price'], 'unit_id': '0', 'total_price': this.model['bed_total'], 
        'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
        'invoice_item_id': '0', 'tax_amount': ext_bed_tax.toFixed(2), 
        'type': 'pb', 'key': 'invoice_item_id', 'count': this.invoice_model['bed_count'],
        'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0',
        'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 'primary_quantity': '0',
        'comment': (this.applicationConstants.user_lang == 'ar' ? 'أسرة إضافية' : 'Additional Beds'), 
        'revenue_acct_no': this.revenue_acct_no
      });
    }

    //------------------------ Save ------------------------//

    console.log(values);

    if (this.invoice_model['invoice_id'] == '0') {
      let year = this.model['invoice_date'].getFullYear();
      this.invoice_model['year'] = String(year);

      let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      let prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

      obj = {
        cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
        prefix: prefix, idWhere: idWhere
      };
    }
    else {
      // delete 
      this.toDelete.forEach(delElem => {
        if (delElem['table_name'] == 'invoice_item') {
          values.push({
            'table_name': delElem['table_name'], 'invoice_item_id': delElem.invoice_item_id,
            'key': 'invoice_item_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'trip_group') {
          values.push({
            'table_name': delElem['table_name'], 'group_id': delElem.group_id,
            'key': 'group_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'reg_on_hotel') {
          values.push({
            'table_name': delElem['table_name'], 'reg_id': delElem.reg_id,
            'key': 'reg_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'reg_on_visa') {
          values.push({
            'table_name': delElem['table_name'], 'reg_visa_id': delElem.reg_visa_id,
            'key': 'reg_visa_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
        else if (delElem['table_name'] == 'reg_on_bus') {
          values.push({
            'table_name': delElem['table_name'], 'reg_bus_id': delElem.reg_bus_id,
            'key': 'reg_bus_id', 'flag': 'delete', 'invoice_no': this.invoice_model['invoice_no']
          });
        }
      });

      obj = { cmd: 'updateAdv', values: values };
    }

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {

          if (this.invoice_model['invoice_id'] == '0') 
            this.invoice_model['invoice_no'] = data.status['msg'][0]['number'];

          // check if it is new invoice OR updated one and has no cash receipt OR 
          // updated one and has cash receipt and the invoice total has changed and 
          // there is cash receipt for this invoice, then link or fix the cash receipt
          if (this.model['has_cash_receipt'] == 0 || 
            (this.model['has_cash_receipt'] == 1 && this.model['old_total_amount'] != Number(this.model['total_amount']))) {

            obj = {
              cmd: 'updateCashReceipt', invoice_no: this.invoice_model['invoice_no'],
              user_name: this.applicationConstants.user_info['user_name']
            };

            this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'error')
                  alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
              
                alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
                window.open(this.applicationConstants.contractPrint + "?invoice_no=" + this.invoice_model['invoice_no'] + 
                  "&lang=" + this.applicationConstants.user_lang, "_blank");
                  
                if (this.acct_number == '')
                  this.router.navigate(['sub_menu/13/tour_invoice_list']);
                else 
                  this.router.navigate(['sub_menu/13/preregister_list']);
                
              });
          }
          else {
            alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
            window.open(this.applicationConstants.contractPrint + "?invoice_no=" + this.invoice_model['invoice_no'] + 
              "&lang=" + this.applicationConstants.user_lang, "_blank");
            if (this.acct_number == '')
              this.router.navigate(['sub_menu/13/tour_invoice_list']);
            else 
              this.router.navigate(['sub_menu/13/preregister_list']);
          }
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }

}
